export enum ConsentAction {
    Accept = 'accept',
    Decline = 'decline',
    Reject = 'reject',
}
